// Define which app this is - change this for each copy of your project
const APP_IDENTIFIER = "app_0_show_everything";

export { APP_IDENTIFIER };
export { useShowEverything } from '../hooks/useShowEverything';